export const isString = (value) => typeof value === "string";

export const isFunction = (value) => typeof value === "function";

export const isUndefined = (value) => typeof value === "undefined";

export const isNumber = (value) => typeof value === "number" && !isNaN(value);
